export interface GetOraclePriceFeedDecimalsProps {
  loanTokenDecimals: number
  collateralTokenDecimals: number
}

export const ORACLE_PRICE_SCALE_DECIMALS = 36

/**
 * Get the decimals of the oracle price feed.
 *
 * @param loanTokenDecimals - The decimals of the loan token.
 * @param collateralTokenDecimals - The decimals of the collateral token.
 *
 * @returns The decimals of the oracle price feed.
 */
export const getOraclePriceFeedDecimals = ({
  loanTokenDecimals,
  collateralTokenDecimals
}: GetOraclePriceFeedDecimalsProps) => {
  return ORACLE_PRICE_SCALE_DECIMALS + loanTokenDecimals - collateralTokenDecimals
}
